import ch from './ch'
import de from './de'
import { isUserLoggedIn } from '../helpers'

const dictionary = process.env.REACT_APP_LOCALE === 'ch' ? { ...de, ...ch } : (de as any)

const locales = {
  de: 'Deutsch',
  'en-GB': 'English',
  fr: 'Français',
  it: 'Italiana',
  es: 'Español',
  'pt-PT': 'Português',
  nl: 'Dutch',
  da: 'Nederlands',
  fi: 'Suomalainen',
  el: 'Ελληνικά',
  pl: 'Polski',
  nb: 'norsk',
  sv: 'svenska',
  cs: 'čeština',
  sk: 'slovenský',
  sl: 'Slovenščina',
  hu: 'Magyar',
  ro: 'Română',
  bg: 'български',
  et: 'eesti keel',
  lt: 'lietuvių',
  lv: 'latviski',
}

// CountryFlag looks up /flags/{code}.svg by ISO *country* code, but the keys above are
// language codes - only list the ones where the two differ.
const localeFlagCodes: Record<string, string> = {
  'en-GB': 'gb',
  'pt-PT': 'pt',
  da: 'dk',
  el: 'gr',
  nb: 'no',
  sv: 'se',
  sl: 'si',
  et: 'ee',
  cs: 'cz',
}

function setDefaults() {
  localStorage.setItem('locale', 'de')
  localStorage.setItem('dictionary', JSON.stringify(dictionary))
}

function saveLangToDb(locale: string) {
  if (!isUserLoggedIn()) return

  fetch(`${process.env.REACT_APP_API_URL}/user/lang`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lang: locale }),
  }).catch(() => {})
}

function changeLocale(locale: string) {
  saveLangToDb(locale)

  if (locale === 'de') {
    setDefaults()
    window.location.reload()
    return
  }

  fetch(`${process.env.REACT_APP_API_URL}/deepl/translate/${locale}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dictionary),
  })
    .then(r => r.json())
    .then(r => {
      if (!!r && !r.err) {
        localStorage.setItem('locale', locale)
        localStorage.setItem('dictionary', JSON.stringify(r))
        saveLangToDb(locale)
        window.location.reload()
      }
    })
}

function getLocale() {
  const locale = localStorage.getItem('locale') ?? 'de'

  if (locale === 'de') {
    setDefaults()
  }

  window.dictionary = JSON.parse(localStorage.getItem('dictionary') as string)

  return locale
}

function t(key: string) {
  return window.dictionary[key] ?? key
}

export { changeLocale, getLocale, locales, localeFlagCodes, t }
